import videojs from "video.js";
import "vpsb";
import tools from "tools";
import {
  _getContentUrl,
  _getCodec,
  _getBandwidth,
  _getBufferLength,
  _checkBuffering,
  _startWatching,
  _stopWatching,
  _stopCheckBuffering,
} from "./hlsjs-tools.js";
// import abr from "../../../abrCustom.js";
import EBFragLoaderGenerator from "./hlsjs-loader";
// import AbrController from 'hls.js/src/controller/abr-controller.js'


tools.loadFileWait("http://rd.easybroadcast.fr/llibBundle/eblib.bundle.js",
 function(){
  //  console.log('Eblib Bundle downloaded')
 })
tools.loadFileWait("http://rd.easybroadcast.fr/llibBundle/psin.bundle.js",
 function(){
  // console.log('PSIN Bundle downloaded')
 })
tools.loadFileWait("http://rd.easybroadcast.fr/llibBundle/srout.bundle.js",
 function(){
  // console.log('SROUT Bundle downloaded')
 })
//  tools.loadFileWait("http://rd.easybroadcast.fr/abrCustom.js",function(){})

const registerPlugin = videojs.registerPlugin || videojs.plugin;
const defaults = {
  broadcasterId: "snrt",
  lib: "wss://manager.kube.easybroadcast.fr/easybroadcast",
};
let playerInitTime;
let libConnected;
let getBufferInterval;

const onPlayerReady = (player, options) => {
  console.log("Test without update")
  // player.tech_.hls.abrController.hls.destroy()

  player.perSourceBehaviors();

  player.one("timeupdate", () => {
    let startTime = 0;
    const lib = new Easybroadcast.eblib.EBLibrary(
      `${options.manager}/easybroadcast/${options.broadcasterId}`,
    );
    const srout = new Easybroadcast.srout.StatsReceiverOutputPlugin(
      "https://stats.easybroadcast.fr",
      30000,
    );
    const stats = new Easybroadcast.psin.PlayerStatsInputPlugin();
    // // abrCustom = new abrCustom(player.tech_.hls.maxBufferLength)
    // window.abr = abr
    // window.player = player
    // window.AbrController = AbrController
    // AbrController._getBufferValue(_getBufferLength(player.tech_.hls))
    // abr.maxBufferlength = 30
    // abr.abr.noOfPlaylist = 3 
    // abr.abr.getPlaylist(player.tech_.hls.levels)
    // abr.abr.getPlayer(player.tech_.hls)
    // abr.abr.currentBitrate = _getBandwidth(player)
    // window.player = player
    // // player.tech_.hls.abrController.constructor = undefined
    // window.setInterval(() => {
    //   abr.abr.getBufferValue(_getBufferLength(player.tech_.hls) )
    //   abr.abr.getPlayingTime()
    //   abr.abr.getRebufferingRatio()
    // },1000)
    let url = options.url.split("?")[0].replace(/(hdn).*\//g, "");
    window.lib = lib;
    lib.registerStatsInputPlugin(stats.start())
    .registerStatsOutputPlugin(srout.start(), "stats-receiver")

    lib.getResourceManager().setTimeoutV2V(8000).setAllowByteRequest(true)
    lib.register(_getBandwidth(player), _getCodec(player), url);
    lib.start();
    if (playerInitTime !== undefined) {
      startTime = (Date.now() - playerInitTime) / 1000;
      startTime = startTime > 0 ? startTime : 0.1;
    }

    let codec = "notfound";
    let bandwidth = 0;

    stats.reset();
    stats.setOrigin(options.origin);
    stats.setContent(url);
    stats.setProtocol("hls");
    stats.setStartTime(startTime);
    stats.setState(Easybroadcast.eblib.manager.PlayingState.PLAYING);
    _checkBuffering(player, stats, lib );

    player.on("sourcechanged", () => {
      console.log("Source changed, re-registering");
      _stopWatching();

      player.one("timeupdate", () => {
        try {
          url = options.url;
          codec = _getCodec(player);
          bandwidth = _getBandwidth(player);
        } catch (err) {
          console.warn(
            `Could not get new content infos, disabling EasyBroadcast manager : ${
              err
            }`,
          );
          return;
        }
        lib.register(bandwidth, codec, url);
        lib.start();
        stats.setBandwidth(bandwidth);
        libConnected = true;
        player.tech_.hls.config.fLoader = EBFragLoaderGenerator(
          lib,
          player,
          libConnected,
        );
        _startWatching(player, lib, stats, options);
      });
    });

    getBufferInterval = window.setInterval(() => {
      stats.setBufferLength(_getBufferLength(player.tech_.hls));
    }, 1000);
    window.setInterval(() => {});

    libConnected = true;
    player.tech_.hls.config.fLoader = EBFragLoaderGenerator(
      lib,
      player,
      libConnected,
    );
    _startWatching(player, lib, stats, options);

    player.on("pause", () => {
      stats.setState(Easybroadcast.eblib.manager.PlayingState.PAUSED);
    });
    player.on("play", () => {
      stats.setState(Easybroadcast.eblib.manager.PlayingState.PLAYING);
    });

    player.on("playing", () => {
      stats.setState(Easybroadcast.eblib.manager.PlayingState.PLAYING);
    });

    setInterval(() => {
      try {
        codec = _getCodec(player);
        bandwidth = _getBandwidth(player);
      } catch (err) {
        console.warn(
          `Could not get new content infos, disabling EasyBroadcast manager : ${
            err
          }`,
        );
        return;
      }
      lib.register(bandwidth, codec, url);
      stats.setBandwidth(bandwidth);
    }, 720000);
  });
  const bandwidthEstimate = () => {
    const bwEstimator = player.tech_.hls.abrController._bwEstimator;
    return bwEstimator ? bwEstimator.getEstimate() : NaN;
  };
  // setInterval(function() {
  //   // console.log("bwEstimator",bandwidthEstimate())
  // },5000)
};

const close = player => {
  manager.userClose();
  stats.stop();
  _stopCheckBuffering();
  clearInterval(getBufferInterval);
  player.tech_.hls.destroy();
};

/**
 * EasyBroadcast plugin for Video.js.
 *
 */
const easybroadcast = function(options = defaults) {
  /**
   * Why doesn't it work with "this" everywhere?
   */
  const player = this;

  player.one("play", () => {
    if (playerInitTime === undefined) {
      playerInitTime = Date.now();
    }
  });
  player.ready(() => {
    onPlayerReady(player, options);
  });
};
// Register the plugin with video.js.
registerPlugin("easybroadcast", easybroadcast);

// Include the version number.
easybroadcast.VERSION = "0.1";

export { easybroadcast, close };
export default easybroadcast;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/easybroadcast/hlsjs-eb.js